import {useLoggerServiceToken} from '@/di/di.root-container.hooks';

import {Component, ErrorInfo, FC, PropsWithChildren, ReactNode} from 'react';

import {FrontendError} from '@/services/ErrorsService/FrontendError';
import {LoggerService} from '@/services/LoggerService/LoggerService';
import {AppErrorFullScreen} from '@/ui/common/AppError/AppErrorFullScreen/AppErrorFullScreen';
import {Layout} from '@/ui/kit/Layout/Layout';

import s from './ErrorBoundary.module.css';

interface ErrorBoundaryProps {
  children: ReactNode;
}
interface ErrorBoundaryInnerProps extends ErrorBoundaryProps {
  loggerService: LoggerService;
}

interface ErrorBoundaryState {
  error: FrontendError | null;
  errorInfo: ErrorInfo | null;
}

export const ErrorBoundary: FC<ErrorBoundaryProps> = ({children}) => {
  const loggerService = useLoggerServiceToken();

  return <ErrorBoundaryInner loggerService={loggerService}>{children}</ErrorBoundaryInner>;
};

class ErrorBoundaryInner extends Component<PropsWithChildren<ErrorBoundaryInnerProps>, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryInnerProps) {
    super(props);

    this.state = {error: null, errorInfo: null};
  }

  static getDerivedStateFromError(error: Error): {error: Error} {
    const boundaryError = FrontendError.createBoundaryError(error);

    return {error: boundaryError};
  }

  componentDidCatch(): void {
    if (this.state.error) {
      this.props.loggerService.logErrorBoundaryError(this.state.error);
    }
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <Layout enableDiv100vh classNameMain={s.errorContainer}>
          <AppErrorFullScreen error={this.state.error} />
        </Layout>
      );
    }

    return this.props.children;
  }
}
